import { fetchAuthSession } from 'aws-amplify/auth';
import { post, put, del } from 'aws-amplify/api';
import { useMutation, useQueryClient } from 'react-query';
import { ALLERGIES_QUERY_KEY } from './useAllergiesQuery';


export const useAllergiesPostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: 'hrallergiesapi',
        path: '/allergies',
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ALLERGIES_QUERY_KEY] });
    },
  });
};

export const useAllergiesPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: 'hrallergiesapi',
        path: '/allergies',
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ALLERGIES_QUERY_KEY] });
    },
  });
};

export const useAllergiesDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const session = await fetchAuthSession();
      const { body } = await del({
        apiName: 'hrallergiesapi',
        path: '/allergies',
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          queryParams: { id: id },
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ALLERGIES_QUERY_KEY] });
    },
  });
};
